var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5392 2.16675H8.46085C4.51752 2.16675 2.16669 4.51758 2.16669 8.46092V17.5284C2.16669 21.4826 4.51752 23.8334 8.46085 23.8334H17.5284C21.4717 23.8334 23.8225 21.4826 23.8225 17.5392V8.46092C23.8334 4.51758 21.4825 2.16675 17.5392 2.16675ZM13 19.7709C11.0609 19.7709 9.54419 18.8067 8.51502 17.8534V18.6226C8.51502 19.0667 8.14669 19.4351 7.70252 19.4351C7.25835 19.4351 6.89002 19.0667 6.89002 18.6226V15.6434C6.89002 15.1992 7.25835 14.8309 7.70252 14.8309H10.3892C10.8334 14.8309 11.2017 15.1992 11.2017 15.6434C11.2017 16.0876 10.8334 16.4559 10.3892 16.4559H9.41419C10.2159 17.2576 11.4617 18.1459 13 18.1459C15.8384 18.1459 18.1459 15.8384 18.1459 13.0001C18.1459 12.5559 18.5142 12.1876 18.9584 12.1876C19.4025 12.1876 19.7709 12.5559 19.7709 13.0001C19.7709 16.7376 16.7375 19.7709 13 19.7709ZM19.7709 10.3351C19.7709 10.3676 19.7709 10.4001 19.7709 10.4217C19.76 10.5409 19.7275 10.6492 19.6734 10.7467C19.6192 10.8442 19.5434 10.9309 19.4459 11.0067C19.37 11.0609 19.2834 11.1042 19.1859 11.1367C19.11 11.1584 19.0342 11.1692 18.9584 11.1692H16.3259C15.8817 11.1692 15.5134 10.8009 15.5134 10.3567C15.5134 9.91258 15.8817 9.54425 16.3259 9.54425H17.225C16.3584 8.74258 14.9609 7.85425 13.0217 7.85425C10.1834 7.85425 7.87585 10.1617 7.87585 13.0001C7.87585 13.4442 7.50752 13.8126 7.06335 13.8126C6.61919 13.8126 6.22919 13.4442 6.22919 13.0001C6.22919 9.26258 9.26252 6.22925 13 6.22925C15.3292 6.22925 17.0409 7.23675 18.1459 8.20092V7.37758C18.1459 6.93341 18.5142 6.56508 18.9584 6.56508C19.4025 6.56508 19.7709 6.93341 19.7709 7.37758V10.3351Z",
    fill: "url(#paint0_linear_330_10393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_10393",
    x1: 2.16669,
    y1: 13.0001,
    x2: 23.8226,
    y2: 13.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon4);
export default __webpack_public_path__ + "static/media/features-icon-4.18971d4d5407c06d9dca64970c601864.svg";
export { ForwardRef as ReactComponent };